import DgVxeTable from './src/main.vue'

// 为组件提供 install 安装方法，供按需引入
DgVxeTable.install = function (Vue) {
  Vue.component(DgVxeTable.name, DgVxeTable)
}
export default DgVxeTable

export { DgVxeTable }